module.exports = __webpack_public_path__ + "img/error.00c6d979.png";